export const secretKey = `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`;
export const baseURL = `https://api.stripe.com`;